module.exports = __webpack_public_path__ + "media/images/pokerroom/redstar/step3-full-4ddfd908b533c41e2346dc806b588739.jpg";